module.exports = require('./dist/src/components/button-next');
